import { Link } from "react-router-dom";
import { Phone, ArrowUpRight } from "lucide-react";
import { PHONE, TEL } from "@/data/site";

export const CallButton = ({ testId, dark = false, label, className = "" }) => (
  <a
    href={TEL}
    data-testid={testId}
    className={`group inline-flex items-center justify-center gap-3 rounded-full border px-6 py-3.5 text-sm font-semibold transition-colors duration-300 ${
      dark ? "border-white/40 text-white hover:bg-white hover:text-[#14263D]" : "border-[#14263D]/30 text-[#14263D] hover:bg-[#14263D] hover:text-white"
    } ${className}`}
  >
    <Phone className="h-4 w-4 transition-transform duration-300 group-hover:-rotate-12" />
    {label || `Call ${PHONE}`}
  </a>
);

export const ConsultButton = ({ testId, label = "Request a Free Consultation", to = "/contact", dark = false, className = "" }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`btn-sweep ${dark ? "on-dark" : ""} group inline-flex items-center justify-center gap-3 rounded-full bg-[#A52A32] px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-300 ${className}`}
  >
    {label}
    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </Link>
);

export const TextLink = ({ to, children, testId, light = false }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`group inline-flex items-center gap-2 text-sm font-semibold ${light ? "text-white" : "text-[#14263D]"}`}
  >
    <span className="link-underline pb-0.5">{children}</span>
    <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#A52A32] text-white transition-transform duration-300 group-hover:translate-x-1">
      <ArrowUpRight className="h-4 w-4" />
    </span>
  </Link>
);
